module.exports = __webpack_public_path__ + "static/media/selected-feedback-thumbs-up.a81ca0c0.svg";